export const LocalStorageKeys = {
    'ACCESS_TOKEN': 'access-token'
}